module.exports = __webpack_public_path__ + "static/media/escudoUnal.4da6e3ae.svg";